import GeneralIcon from "../../../../../assets";

export default function EmptyStateVariants() {
  return (
    <div className="text-center py-12 text-gray-400">
      <GeneralIcon iconName="vazio" className="mx-auto mb-4 h-32 w-32" />
      <div className="text-sm">Nenhuma variante adicionada</div>
    </div>
  );
}
